import React from 'react'
import styles from './UIGameVoteParticipants.module.scss'
import {PlayerColor} from '@colonist/game-states'
import {useUIGamePlayersContext} from '../../../contexts/UIGamePlayersContext'
import {Avatar} from '../../../common/Avatar'
import IconPlayerStatusAccept from '@static/images/player_status_accept.svg'
import IconPlayerStatusReject from '@static/images/player_status_reject.svg'
import IconPlayerStatusPending from '@static/images/player_status_pending.svg'

const getStatusIcon = ({
    isAccepted,
    isDeclined,
    isPending,
}: {
    isAccepted: boolean
    isDeclined: boolean
    isPending: boolean
}): string | undefined => {
    if(isAccepted) return IconPlayerStatusAccept
    if(isDeclined) return IconPlayerStatusReject
    if(isPending) return IconPlayerStatusPending
    return undefined
}

export interface UIGameVoteParticipantsProps {
    acceptedVotes: PlayerColor[]
    declinedVotes: PlayerColor[]
    participatingPlayers: PlayerColor[]
}

export const UIGameVoteParticipants = ({acceptedVotes, declinedVotes, participatingPlayers}: UIGameVoteParticipantsProps) => {
    const {getPlayerValidator} = useUIGamePlayersContext()

    return (
        <div className={styles.playersContainer}>
            {participatingPlayers.map((playerColor) => {
                const player = getPlayerValidator(playerColor)
                if(player == null) return null

                const isAccepted = acceptedVotes.includes(playerColor)
                const isDeclined = declinedVotes.includes(playerColor)
                const isPending = !isAccepted && !isDeclined

                return (
                    <div key={playerColor} className={styles.playerWrapper}>
                        <Avatar
                            color={player.color}
                            className={styles.avatar}
                            image={player.displayIcon}
                            profilePictureUrl={player.profilePictureUrl}/>
                        <img src={getStatusIcon({
                            isAccepted: isAccepted,
                            isDeclined: isDeclined,
                            isPending: isPending,
                        })} className={styles.statusIcon}/>
                    </div>
                )
            })}
        </div>
    )
}
